import React from 'react';
import LessonView from '../Lessons/LessonView';

type LessonCardProps = {
  planTitle: string;
  planId: string;
  lessonIndex: number;
  lessonInstance: any;
  completionStatus?: 'not_started' | 'in_progress' | 'completed' | string;
  onExerciseAnswered?: (payload: { lessonIndex: number; sectionIndex: number; exerciseIndex: number; answer: string; fullExercise: any }) => void;
};

const LessonCard: React.FC<LessonCardProps> = ({ planTitle, planId, lessonIndex, lessonInstance, completionStatus, onExerciseAnswered }) => {
  return (
    <LessonView
      planTitle={planTitle}
      planId={planId}
      lessonIndex={lessonIndex}
      lessonInstance={lessonInstance}
      completionStatus={completionStatus}
      onExerciseAnswered={onExerciseAnswered}
    />
  );
};

export default LessonCard;


